import { greetingProvider } from "./greetingProvider";
import { timeTrackingProvider } from "./timeTrackingProvider";
import { payrollProvider } from "./payrollProvider";
import { accountsReceivableProvider } from "./accountsReceivableProvider";
import { accountsPayableProvider } from "./accountsPayableProvider";
import { estimatesProvider } from "./estimatesProvider";
import { closingProvider } from "./closingProvider";

/**
 * Ordered executive briefing section providers.
 * Add future providers (Gmail, Calendar, Weather, etc.) to this list.
 */
export const EXECUTIVE_BRIEFING_PROVIDERS = Object.freeze([
  greetingProvider,
  timeTrackingProvider,
  payrollProvider,
  accountsReceivableProvider,
  accountsPayableProvider,
  estimatesProvider,
  closingProvider,
]);
